<app-header [text]="'MOT.VACATIONS.DETAIL.TITLE' | translate" [scrollArea]="pageWrapper"></app-header>

<app-content #pageWrapper>
  <app-total-vacations-detail></app-total-vacations-detail>
</app-content>

<app-menu></app-menu>
